<template>
  <div class="content-breadcrumb">
    <div class="content-breadcrumb-div">
      <router-link
        tag="a"
        :to="{ name: item.routerName, ...item.routerParams }"
        class="content-breadcrumb-div--links"
        :class="{ 'active--link': links?.length - 1 === index }"
        v-for="(item, index) in links"
        :key="index"
      >
        <p>{{ item.name }}</p>
        <template v-if="links?.length - 1 !== index">
          <svg
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_35_1490"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="7"
              height="12"
              style="mask-type: luminance"
            >
              <path
                d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                fill="white"
              ></path>
            </mask>
            <g mask="url(#mask0_35_1490)">
              <path
                d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                fill="black"
              ></path>
            </g>
          </svg>
        </template>
      </router-link>
    </div>
    <div
      class="content-breadcrumb-btns"
      :class="{ 'content-breadcrumb-btns--plans': $route.name === 'EditPlans' }"
    >
      <div class="content-switch" v-if="$route.name === 'RegisterPosts'">
        <p class="content-switch--text">Destaque?</p>
        <label class="switch">
          <input
            type="checkbox"
            name="switch-highlight"
            v-model="is_highlight"
          />
          <span class="slider round"></span>
        </label>
      </div>
      <div class="content-switch" v-if="pagesPremium.indexOf($route.name) > -1">
        <p class="content-switch--text">Conteúdo Premium?</p>
        <label class="switch">
          <input
            type="checkbox"
            name="switch-premium"
            v-model="isPlanPremium"
          />
          <span class="slider round"></span>
        </label>
      </div>
      <button class="btn--delete" @click="remove()" v-if="checkEnableRemove()">
        <img
          class="img-fluid"
          src="@/assets/img/icon-delete.png"
          alt="icon delete"
          title="icon delete"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      highlight: false,
      planParams: this.$route.params,
      pagesPremium: [
        "RegisterPosts",
        "RegisterPlans",
        "EditPlans",
        "RegisterMeditation",
        "EditMeditation",
        "MeditationRegisterTask",
        "MeditationEditTask",
        "RegisterMusic",
        "EditMusic",
        "RegisterHumor",
        "EditHumor",
      ],
    };
  },
  props: ["links", "data"],
  computed: {
    is_highlight: {
      get() {
        return this.$store.getters["Blog/isHighlight"];
      },
      set(newHighlight) {
        this.setDataDefault(["Blog/SET_IS_HIGHLIGHT", newHighlight]);
      },
    },
    isPlanPremium: {
      get() {
        return this.$store.getters[`${this.data.module}/isPremium`];
      },
      set(newValue) {
        this.setDataDefault([`${this.data.module}/SET_IS_PREMIUM`, newValue]);
      },
    },
    ...mapGetters("Tasks", ["currentTask"]),
  },
  methods: {
    ...mapActions(["setDataDefault"]),
    ...mapActions("Blog", ["removePost"]),
    ...mapActions("Ebooks", ["removeEbook"]),
    ...mapActions("Plans", ["removePlan"]),
    ...mapActions("Meditation", [
      "removeMeditation",
      "removeTask",
      "removeMusic",
    ]),
    ...mapActions("Tasks", [
      "removePhraseDiary",
      "removeText",
      "removeChallenge",
    ]),
    ...mapActions("Humor", ["removeAllQuestions"]),
    ...mapActions("Professional", [
      "removeSpecialty",
      "removeTargetAudience",
      "removeDaysOfTheWeek",
      "removeStatusSchedule",
    ]),
    ...mapActions("Company", [
      "removeCompany",
      "removePlan",
      "removePosition",
      "removeDepartment",
      "removeLeadStatus",
    ]),
    async removeFunctions() {
      if (this.data.name === "Post") {
        await this.removePost(this.data.id);
        this.$router.push({ name: "Blog" });
        return;
      }

      if (this.data.name === "Ebook") {
        await this.removeEbook(this.data.id);
        this.$router.push({ name: "Ebooks" });
        return;
      }

      if (this.data.name === "Plano") {
        await this.removePlan(this.data.id);
        this.$router.push({ name: "Plans" });
        return;
      }

      await this.removeFunctionsTask();
      await this.removeFunctionsMeditation();
      await this.removeFunctionsProfessional();
      await this.removeFunctionsCompany();
    },
    async removeFunctionsTask() {
      if (this.data.type === "FraseDiaria") {
        let obj = { id_task: this.currentTask.id, id: this.data.id };
        await this.removePhraseDiary(obj);
        this.$router.push({ name: "RegisterContents" });
        return;
      }

      if (this.data.type === "Text") {
        let obj = { id_task: this.currentTask.id, id: this.data.id };
        await this.removeText(obj);
        this.$router.push({ name: "RegisterContents" });
        return;
      }

      if (this.data.type === "Desafios") {
        let obj = { id_task: this.currentTask.id, id: this.data.id };
        await this.removeChallenge(obj);
        this.$router.push({ name: "RegisterContents" });
      }
    },
    async removeFunctionsMeditation() {
      if (this.data.type === "Meditation") {
        await this.removeMeditation(this.data.id);
        this.$router.push({ name: "Meditation" });
        return;
      }

      if (this.data.type === "MeditationTask") {
        await this.removeTask(this.data.id);
        this.$router.push({
          name: "MeditationTasks",
          params: {
            id: this.data.id_meditation,
          },
        });
        return;
      }

      if (this.data.type === "MeditationMusic") {
        await this.removeMusic(this.data.id);
        this.$router.push({ name: "ListMusics" });
        return;
      }

      if (this.data.type === "HumorQuestions") {
        await this.removeAllQuestions(this.data);
        this.$router.push({ name: "ListHumorQuestions" });
      }
    },
    async removeFunctionsProfessional() {
      if (this.data.type === "Specialty") {
        await this.removeSpecialty(this.data.id);
        this.$router.push({ name: "ListSpecialties" });
        return;
      }

      if (this.data.type === "TargetAudience") {
        await this.removeTargetAudience(this.data.id);
        this.$router.push({ name: "ListTargetAudience" });
        return;
      }

      if (this.data.type === "DaysOfTheWeek") {
        await this.removeDaysOfTheWeek(this.data.id);
        this.$router.push({ name: "ListDaysOfTheWeek" });
        return;
      }

      if (this.data.type === "StatusSchedule") {
        await this.removeStatusSchedule(this.data.id);
        this.$router.push({ name: "ListStatusSchedule" });
      }
    },
    async removeFunctionsCompany() {
      if (this.data.type === "Company") {
        await this.removeCompany(this.data.id);
        this.$router.push({ name: "ListCompanies" });
        return;
      }

      if (this.data.type === "Plan") {
        await this.removePlan(this.data.id);
        this.$router.push({ name: "ListCompanyPlans" });
        return;
      }

      if (this.data.type === "Department") {
        await this.removeDepartment(this.data.id);
        this.$router.push({ name: "ListDepartments" });
        return;
      }

      if (this.data.type === "LeadStatus") {
        await this.removeLeadStatus(this.data.id);
        this.$router.push({ name: "ListLeadsStatus" });
        return;
      }
    },
    remove() {
      this.$swal
        .fire({
          html: `Tem certeza que deseja deletar o
        <b style=" display: block; font-size: 24px; color: #EF0000;">${this.data.name}?<b>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#EF0000",
          confirmButtonText: "SIM",
          cancelButtonText: "NÃO",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.removeFunctions();
            this.$swal.fire({
              icon: "success",
              html: `${this.data.name} removido com sucesso!`,
            });
          }
        });
    },
    checkEnableRemove() {
      let routerName = this.$route.name;
      let pagesRoutes = [
        "MenuTasks",
        "RegisterMeditation",
        "RegisterNarration",
        "EditNarration",
        "MeditationRegisterTask",
        "RegisterMusic",
        "RegisterHumorQuestions",
        "MenuCompany",
        "RegisterCompany",
        "EditCompany",
        "ListPlansCompany",
        "RegisterPlanCompany",
        "EditPlanCompany",
        "ListAdminsCompany",
        "RegisterAdminCompany",
        "EditAdminCompany",
        "ListCollaboratorsCompany",
        "RegisterCollaboratorCompany",
        "EditCollaboratorCompany",
      ];
      if (
        this.data &&
        Object.values(this.data).length > 0 &&
        pagesRoutes.indexOf(routerName) === -1
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-breadcrumb {
  position: relative;
  padding: 30px 0px 20px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 991px) {
    padding: 70px 0px 20px 0px;
  }
  &-div {
    // width: calc(100% - 170px);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    @media (max-width: 991px) {
      width: 100%;
    }
    &--links {
      display: flex;
      align-items: center;
      text-align: left;
      margin-right: 10px;
      margin-bottom: 10px;
      transition: 500ms;
      &:last-child {
        margin-right: 0;
      }
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.6;
      }
      p {
        font-size: 14px;
        font-family: "Font Regular";
        color: var(--black);
        margin-right: 10px;
        margin-bottom: 0;
      }
    }
  }
  &-btns {
    display: flex;
    align-items: center;
    @media (max-width: 991px) {
      position: absolute;
      top: 15px;
      right: 0;
    }
    .content-switch {
      display: flex;
      align-items: center;
      margin-right: 15px;
      margin-bottom: 10px;
      @media (max-width: 991px) {
        margin-bottom: 0;
      }
      &--text {
        font-size: 12px;
        font-family: "Font Light";
        color: var(--black);
        margin-right: 10px;
        margin-bottom: 0;
      }
      .switch {
        position: relative;
        display: inline-block;
        width: 51px;
        height: 26px;
        margin-bottom: 0;
      }
      /* Hide default HTML checkbox */
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      /* The slider */
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--red-dark);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 3px;
        bottom: 3px;
        background-color: var(--white);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      input:checked + .slider {
        background-color: var(--green);
      }
      input:checked + .slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
      }
      /* Rounded sliders */
      .slider.round {
        border-radius: 20px;
      }
      .slider.round:before {
        border-radius: 100%;
      }
    }
    .btn--delete {
      background: 0;
      border: 0;
      padding: 0;
      margin-bottom: 10px;
      transition: 500ms;
      @media (max-width: 991px) {
        margin-bottom: 0;
      }
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    &--plans {
      @media (max-width: 991px) {
        width: 100%;
        justify-content: space-between;
      }
    }
  }
}
.active--link {
  p {
    color: var(--yellow-dark);
    font-family: "Font Semibold";
  }
}
</style>
